import React from 'react';
import { motion } from 'framer-motion';

const Logo = ({ size = 'md', showText = true, animate = true }) => {
  // Size variants
  const sizes = {
    xs: { width: 28, height: 28, textSize: 'text-xs' },
    sm: { width: 36, height: 36, textSize: 'text-sm' },
    md: { width: 48, height: 48, textSize: 'text-base' },
    lg: { width: 64, height: 64, textSize: 'text-lg' },
    xl: { width: 96, height: 96, textSize: 'text-2xl' },
    '2xl': { width: 128, height: 128, textSize: 'text-3xl' }
  };

  const { width, height, textSize } = sizes[size] || sizes.md;

  const pulseAnimation = animate ? {
    scale: [1, 1.05, 1, 1.02, 1],
    filter: [
      'drop-shadow(0 0 8px rgba(255, 42, 42, 0.6))',
      'drop-shadow(0 0 16px rgba(255, 42, 42, 0.9))',
      'drop-shadow(0 0 8px rgba(255, 42, 42, 0.6))',
      'drop-shadow(0 0 12px rgba(255, 42, 42, 0.75))',
      'drop-shadow(0 0 8px rgba(255, 42, 42, 0.6))'
    ]
  } : {};

  const pulseTransition = animate ? {
    duration: 1.2,
    repeat: Infinity,
    ease: 'easeInOut'
  } : {};

  return (
    <div className="flex items-center gap-2">
      <motion.svg
        width={width}
        height={height}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        animate={pulseAnimation}
        transition={pulseTransition}
        className="drop-shadow-[0_0_10px_rgba(255,42,42,0.6)]"
        data-testid="pulsate-logo"
      >
        {/* Heart shape */}
        <path
          d="M50 88C50 88 12 58 12 35C12 20 24 10 38 10C45 10 50 14 50 14C50 14 55 10 62 10C76 10 88 20 88 35C88 58 50 88 50 88Z"
          stroke="#FF2A2A"
          strokeWidth="3"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="drop-shadow-[0_0_4px_rgba(255,42,42,0.8)]"
        />
        
        {/* Inner heart glow */}
        <path
          d="M50 88C50 88 12 58 12 35C12 20 24 10 38 10C45 10 50 14 50 14C50 14 55 10 62 10C76 10 88 20 88 35C88 58 50 88 50 88Z"
          fill="rgba(255, 42, 42, 0.1)"
        />

        {/* EKG Line - jagged heartbeat pattern going through the heart */}
        <motion.path
          d="M8 50 L25 50 L30 50 L35 35 L40 65 L45 30 L50 70 L55 35 L60 55 L65 45 L70 50 L92 50"
          stroke="#00F0FF"
          strokeWidth="2.5"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="drop-shadow-[0_0_6px_rgba(0,240,255,0.9)]"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{ duration: 1.5, ease: 'easeInOut' }}
        />

        {/* PG Text */}
        <text
          x="50"
          y="58"
          textAnchor="middle"
          className="font-black"
          style={{
            fontSize: '22px',
            fontFamily: 'Unbounded, sans-serif',
            fontWeight: 900,
            fill: '#FFFFFF',
            filter: 'drop-shadow(0 0 4px rgba(255, 255, 255, 0.5))'
          }}
        >
          PG
        </text>
      </motion.svg>

      {showText && (
        <div className="flex flex-col">
          <span 
            className={`font-black tracking-tighter text-white ${textSize}`}
            style={{ fontFamily: 'Unbounded, sans-serif' }}
          >
            Pulsate
          </span>
          <span className="text-[10px] tracking-[0.3em] text-[#00F0FF] uppercase font-semibold -mt-1">
            GLOBAL
          </span>
        </div>
      )}
    </div>
  );
};

// Compact logo for small spaces (just the icon)
export const LogoIcon = ({ size = 'md', animate = true }) => (
  <Logo size={size} showText={false} animate={animate} />
);

// Full logo with text
export const LogoFull = ({ size = 'md', animate = true }) => (
  <Logo size={size} showText={true} animate={animate} />
);

export default Logo;
